window.addEventListener('load', () => {
    document.querySelectorAll('.top-icon').forEach(icon => {
        icon.addEventListener('click', e => {
            e.preventDefault()
            window.scrollTo({top: 0, behavior: 'smooth'});
        })
    })
})